module.exports = __webpack_public_path__ + "static/uni_tuskegee-8b40efa0cac32f55de7f4e78c5a86a91.png";